<template>
  <section class="nav">
    <div class="nav-spacer" />
    <div class="nav-slider">
      <div class="nav-slider-content">
        <div class="nav-slider-content-items">
          <ButtonBase
            theme="secondary-light"
            stroke="n"
            class="button"
            rounded
            :single-line="true"
            size="small"
            :to="route.path"
          >
            Mon programme
          </ButtonBase>
          <NavigationButtonShortcutSlider
            v-for="category in categories"
            :key="category.id"
            :category="category"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
interface Props {
  categories: CategorySchema[];
}

const route = useRoute();

defineProps({
  categories: null
});
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  left: calc(-1 * var(--gap_n));
  width: calc(100% + 2 * var(--gap_n));
  @include above('l') {
    left: 0;
    width: 100%;
  }
}
.nav-spacer {
  width: 100%;
  height: 3.9rem;
}
.nav-slider {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3.9rem;
  overflow: hidden;

  .settings & {
    width: calc(100% - var(--gap_n));
    border-radius: 0 1.9rem 1.9rem 0;
  }
  &::after {
    display: block;
    position: absolute;
    z-index: 0;
    top: -0.4rem;
    right: -0.4rem;
    width: 4.6rem;
    height: 4.6rem;
    border-radius: 50% 0% 0% 50%;
  }
}
.button-trash {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: 3.9rem;
  height: 3.9rem;
  border-radius: 50%;
  background: var(--color_neutral_100);
  color: var(--color_neutral_900);
}

.nav-slider-content {
  &::before {
    content: '';
    display: inline-block;
    flex: 0 0 auto;
    width: var(--gap_n);
    background: transparent;
    @include above('l') {
      display: none;
    }
  }

  display: inline-flex;
  position: relative;
  justify-content: flex-start;
  height: 6.9rem;
  overflow: visible;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  &-items {
    display: flex;
    height: 3.9rem;
    gap: var(--gap_xs);
    &::after {
      content: '';
      display: block;
      flex: 1 0 auto;
      width: calc(var(--gap_n) - var(--gap_xs));
    }
  }

  @include scrollbars(3rem, var(--color_neutral_0), var(--color_neutral_0));
}
</style>
